export const INIT_AFTER_CALLBACK = "INIT_AFTER_CALLBACK";
export const SIGN_OUT = "SIGN_OUT";
export const SET_LOCALE = "SET_LOCALE";
